'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _defaults;

var _Immutable = require('Immutable');

var _LegalConsentCheckbox = require('MeetingsBase/models/LegalConsentCheckbox');

var _LegalConsentCheckbox2 = _interopRequireDefault(_LegalConsentCheckbox);

var _legalConsent = require('MeetingsBase/constants/legalConsent');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isEmptyParagraph = function isEmptyParagraph(text) {
  return !text || text === '<p></p>';
};

var defaults = (_defaults = {}, _defineProperty(_defaults, _legalConsent.KEYS.IS_LEGITIMATE_INTEREST, false), _defineProperty(_defaults, _legalConsent.KEYS.LEGITIMATE_INTEREST_TEXT, ''), _defineProperty(_defaults, _legalConsent.KEYS.LEGITIMATE_INTEREST_SUBSCRIPTIONS, (0, _Immutable.List)()), _defineProperty(_defaults, _legalConsent.KEYS.LEGITIMATE_INTEREST_LAWFUL_BASIS, null), _defineProperty(_defaults, _legalConsent.KEYS.COMMUNICATION_CONSENT_TEXT, ''), _defineProperty(_defaults, _legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES, (0, _Immutable.List)([new _LegalConsentCheckbox2.default()])), _defineProperty(_defaults, _legalConsent.KEYS.PRIVACY_POLICY_TEXT, ''), _defineProperty(_defaults, _legalConsent.KEYS.IMPLICIT_PROCESSING_CONSENT_TEXT, ''), _defaults);

var LegalConsentOptions = function (_Record) {
  _inherits(LegalConsentOptions, _Record);

  function LegalConsentOptions() {
    _classCallCheck(this, LegalConsentOptions);

    return _possibleConstructorReturn(this, (LegalConsentOptions.__proto__ || Object.getPrototypeOf(LegalConsentOptions)).apply(this, arguments));
  }

  _createClass(LegalConsentOptions, [{
    key: 'hasSubscription',
    value: function hasSubscription(id) {
      return Boolean(this[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES].find(function (subscription) {
        return subscription.communicationTypeId === id;
      }));
    }
  }, {
    key: 'hasLegitimateInterestSubscription',
    value: function hasLegitimateInterestSubscription(id) {
      return this[_legalConsent.KEYS.LEGITIMATE_INTEREST_SUBSCRIPTIONS].includes(id);
    }
  }, {
    key: 'hasEmptySubscription',
    value: function hasEmptySubscription() {
      return Boolean(this[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES].find(function (subscription) {
        return !subscription.communicationTypeId;
      }));
    }
  }, {
    key: 'getNumberOfSubscriptions',
    value: function getNumberOfSubscriptions() {
      return this[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES].size;
    }
  }, {
    key: 'getSubscriptions',
    value: function getSubscriptions() {
      return this[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES];
    }
  }, {
    key: 'getCheckboxLabels',
    value: function getCheckboxLabels() {
      return this[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES].map(function (checkbox) {
        return checkbox.label;
      });
    }
  }, {
    key: 'convertToJSON',
    value: function convertToJSON() {
      var json = this.toJS();
      json[_legalConsent.FORMS_KEYS.PROCESSING_CONSENT_TEXT] = json[_legalConsent.KEYS.IMPLICIT_PROCESSING_CONSENT_TEXT];
      json[_legalConsent.FORMS_KEYS.PROCESSING_CONSENT_TYPE] = _legalConsent.IMPLICIT_PROCESSING_CONSENT_TYPE;

      /*
      * Forms saves legitimateInterestPrivacyPolicyText into privacyPolicyText
      * when isLegitimateInterest is true.
      */
      if (json[_legalConsent.KEYS.IS_LEGITIMATE_INTEREST]) {
        json[_legalConsent.KEYS.PRIVACY_POLICY_TEXT] = json[_legalConsent.KEYS.LEGITIMATE_INTEREST_TEXT];
      }

      delete json[_legalConsent.KEYS.IMPLICIT_PROCESSING_CONSENT_TEXT];
      delete json[_legalConsent.KEYS.LEGITIMATE_INTEREST_TEXT];
      return json;
    }
  }, {
    key: 'createdFromNull',
    value: function createdFromNull() {
      return this.equals(LegalConsentOptions.from(null));
    }
  }, {
    key: 'lacksSubscriptionId',
    value: function lacksSubscriptionId() {
      return this[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES] && this[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES].first() && !this[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES].first()[_legalConsent.CHECKBOX_KEYS.COMMUNICATION_TYPE_ID] || this[_legalConsent.KEYS.LEGITIMATE_INTEREST_SUBSCRIPTIONS].isEmpty();
    }
  }, {
    key: 'lacksLegitimateInterestText',
    value: function lacksLegitimateInterestText() {
      return !this[_legalConsent.KEYS.LEGITIMATE_INTEREST_TEXT];
    }
  }, {
    key: 'allCheckboxesHaveLabels',
    value: function allCheckboxesHaveLabels() {
      return this[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES].every(function (checkbox) {
        return !isEmptyParagraph(checkbox[_legalConsent.CHECKBOX_KEYS.LABEL]);
      });
    }
  }, {
    key: 'filterEmptyConsentSubscriptions',
    value: function filterEmptyConsentSubscriptions() {
      return this.update(_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES, function (checkboxes) {
        return checkboxes.filter(function (checkbox) {
          return Boolean(checkbox[_legalConsent.CHECKBOX_KEYS.COMMUNICATION_TYPE_ID]);
        });
      });
    }
  }, {
    key: 'filterEmptyLegitimateInterestSubscriptions',
    value: function filterEmptyLegitimateInterestSubscriptions() {
      return this.update(_legalConsent.KEYS.LEGITIMATE_INTEREST_SUBSCRIPTIONS, function (subscriptions) {
        return subscriptions.filter(function (subscription) {
          return Boolean(subscription);
        });
      });
    }
  }], [{
    key: 'from',
    value: function from(json) {
      if (json) {
        var _ref;

        return new LegalConsentOptions((_ref = {}, _defineProperty(_ref, _legalConsent.KEYS.IS_LEGITIMATE_INTEREST, json[_legalConsent.KEYS.IS_LEGITIMATE_INTEREST] || false), _defineProperty(_ref, _legalConsent.KEYS.LEGITIMATE_INTEREST_TEXT, this.getLegitimateInterestText(json)), _defineProperty(_ref, _legalConsent.KEYS.LEGITIMATE_INTEREST_SUBSCRIPTIONS, this.getLegitimateInterestSubscriptions(json)), _defineProperty(_ref, _legalConsent.KEYS.LEGITIMATE_INTEREST_LAWFUL_BASIS, json[_legalConsent.KEYS.LEGITIMATE_INTEREST_LAWFUL_BASIS] || _legalConsent.LAWFUL_BASIS_PQL), _defineProperty(_ref, _legalConsent.KEYS.COMMUNICATION_CONSENT_TEXT, json[_legalConsent.KEYS.COMMUNICATION_CONSENT_TEXT]), _defineProperty(_ref, _legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES, this.getCheckboxConfig(json)), _defineProperty(_ref, _legalConsent.KEYS.PRIVACY_POLICY_TEXT, json[_legalConsent.KEYS.PRIVACY_POLICY_TEXT]), _defineProperty(_ref, _legalConsent.KEYS.IMPLICIT_PROCESSING_CONSENT_TEXT, this.getProcessingText(json)), _ref));
      }

      return new LegalConsentOptions();
    }
  }, {
    key: 'getLegitimateInterestText',
    value: function getLegitimateInterestText(json) {
      if (json[_legalConsent.KEYS.IS_LEGITIMATE_INTEREST]) {
        return json[_legalConsent.KEYS.PRIVACY_POLICY_TEXT];
      }
      return json[_legalConsent.KEYS.LEGITIMATE_INTEREST_TEXT];
    }
  }, {
    key: 'getCheckboxConfig',
    value: function getCheckboxConfig(json) {
      var checkboxConfig = json[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES];

      if (checkboxConfig && checkboxConfig.map) {
        return (0, _Immutable.List)(json[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES].map(function (checkbox) {
          return new _LegalConsentCheckbox2.default(checkbox);
        }));
      }
      return (0, _Immutable.List)([new _LegalConsentCheckbox2.default()]);
    }
  }, {
    key: 'getLegitimateInterestSubscriptions',
    value: function getLegitimateInterestSubscriptions(json) {
      var subscriptionsConfig = json[_legalConsent.KEYS.LEGITIMATE_INTEREST_SUBSCRIPTIONS];

      if (subscriptionsConfig && subscriptionsConfig.map) {
        return (0, _Immutable.List)(subscriptionsConfig);
      }
      return (0, _Immutable.List)();
    }
  }, {
    key: 'getProcessingText',
    value: function getProcessingText(json) {
      return json[_legalConsent.FORMS_KEYS.PROCESSING_CONSENT_TEXT] || json[_legalConsent.KEYS.IMPLICIT_PROCESSING_CONSENT_TEXT];
    }
  }]);

  return LegalConsentOptions;
}((0, _Immutable.Record)(defaults));

exports.default = LegalConsentOptions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/models/LegalConsentOptions.js
// module id = 91
// module chunks = 0